import React from 'react';
import { Box, Typography, Stack, Chip, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../../../../app/hooks';
import { removeTeamMember } from '../../../state';

/**
 * TeamMembersList - Component for displaying existing team members with delete functionality
 */
export const TeamMembersList: React.FC = () => {
  const dispatch = useAppDispatch();
  const formData = useAppSelector(state => state.team.currentTeam);

  const handleRemoveMember = (userId: string) => {
    dispatch(removeTeamMember(userId));
  };

  if (!formData?.members || formData.members.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Stack spacing={1}>
          {(formData?.members || []).map((member) => (
            <Box 
              key={member.userId} 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                p: 1.5,
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: 1,
                '&:hover': {
                  backgroundColor: '#f8fafc'
                }
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" fontWeight={500}>
                  {member.displayName}
                </Typography>
                <Typography variant="caption" color="#64748b">
                  {member.email} • {member.role}
                </Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => handleRemoveMember(member.userId)}
                sx={{ 
                  color: '#ef4444',
                  '&:hover': { 
                    backgroundColor: '#fee2e2' 
                  } 
                }}
              >
                <Delete fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Stack>
    </Box>
  );
};

export default TeamMembersList;